import {ACard} from "@atiautomacao/ati-ui-library";
import React, {FunctionComponent, useState} from "react";
import {
    Box,
    Divider,
    Modal, Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import {FindUnavailabilityPowerStationsReactQuery} from "./reactQuery/UnavailabilityReactQuery";
import IconButton from "@mui/material/IconButton";
import {InfoOutlined, SimCardDownloadOutlined} from "@mui/icons-material";
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import ExpandedUnavailabilityChart from "./components/ExpandedUnavailabilityChart";
import UnavailabilityBarChart from "./components/UnavailabilityBarChart";
import themeDefaults from "../../../Shared/Theme/ThemeDefaults";
import {useUnavailabilityLossesExport} from "./hooks/useUnavailabilityLossesExport";
import {CHART_TOOLTIP, UNAVAILABILITY_CHART_TITLE, UNAVAILABILITY_CHART_TITLE_ICON, UnavailabilityChartMode} from "./utils/UnavailabilityChartUtils";

interface UnavailabilityByPowerStationCardProps {
    startDateTime: string;
    endDateTime: string;
    chartMode: UnavailabilityChartMode;
    onChartModeChange: (mode: UnavailabilityChartMode) => void;
}

const UnavailabilityByPowerStationCard: FunctionComponent<UnavailabilityByPowerStationCardProps> = ({startDateTime, endDateTime, chartMode, onChartModeChange}) => {
    const {data, dataMode, isError} = FindUnavailabilityPowerStationsReactQuery(startDateTime, endDateTime, chartMode)
    const [open, setOpen] = useState(false);
    // No modo DIN o arquivo traz a tabela detalhada da visão expandida, mesmo exportado daqui.
    const handleExport = useUnavailabilityLossesExport(startDateTime, endDateTime, chartMode);

    return (
        <>
            <ACard
                ariaLabel={"dashboard-station-inverter-power-x-irradiance"}
                key={`chart-power-irradiance`}
                styleProps={{
                    cardStyle: { height: 485 },
                    contentStyle: { padding: '0 16px', height: 408 },
                    subTitleStyle: { display: 'none'},
                }}
                headerControlsPosition={"header"}
                title={UNAVAILABILITY_CHART_TITLE}
                iconTitle={UNAVAILABILITY_CHART_TITLE_ICON}
                headerActions={
                    <Stack sx={{width: '100%', marginRight: 6}} direction="column" spacing={"2px"}>
                        <Box sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton   onClick={() => {setOpen(true)}}  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}} disabled={false} size="small" >
                                <FullscreenOutlinedIcon sx={{marginRight: '12px'}}/>
                                <Typography variant="body2" >Ver em tela cheia</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                        <Box onClick={() => handleExport("csv")} sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton size="small"  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}}>
                                <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                                <Typography variant="body2">Baixar como CSV</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                        <Box onClick={() => handleExport("excel")} sx={{ width: '100%', display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 5px'}}>
                            <IconButton size="small"  sx={{borderRadius: '4px', width: '100%', justifyContent: 'flex-start'}}>
                                <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                                <Typography variant="body2">Baixar como Excel</Typography>
                            </IconButton>
                        </Box>
                        <Divider />
                    </Stack>
                }
                InformationTooltip={
                    <Stack direction="column" spacing={"2px"}>
                        <Tooltip describeChild title={CHART_TOOLTIP[dataMode]} arrow placement={'top-end'}>
                            <InfoOutlined fontSize='small' style={{backgroundColor: themeDefaults.colors.primary,color: 'white', borderRadius: '50%', border: '1px solid rgba(45, 93, 231, 1)',}}/>
                        </Tooltip>
                    </Stack>
                }
            >
                {(data || isError) &&
                    <UnavailabilityBarChart data={data} mode={dataMode} isError={isError}/>
                }
            </ACard>
            <Modal
                open={open}
                onClose={() => {setOpen(false)}}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <ExpandedUnavailabilityChart
                    startDateTime={startDateTime}
                    endDateTime={endDateTime}
                    chartMode={chartMode}
                    onChartModeChange={onChartModeChange}
                    onClose={() => {setOpen(false)}}
                />
            </Modal>
        </>

    );
}

export default UnavailabilityByPowerStationCard;
